import React, { useCallback } from 'react';

import { FlatList, ListRenderItemInfo, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import gStyles from 'config/styles';

import { selectLayoutConfig } from 'store/config/selectors';

import useHeaderConfig from 'utils/hooks/useHeaderConfig';
import { isWeb } from 'utils/responsiveness';

import SettingsRowItem from '../components/RowItem';
import WebHeader from '../components/WebHeader';
import { SETTINGS_SYSTEM_INFORMATION } from '../languagesConst';
import styles from './styles';
import useAboutDataSource from './useAboutDataSource';

const AboutPage = () => {
    const { t } = useTranslation();

    const { background } = useSelector(selectLayoutConfig);
    const dataSource = useAboutDataSource();

    useHeaderConfig({ isRoot: isWeb, disableFocusOnMount: true });

    const renderItem = useCallback(
        ({ item, index }: ListRenderItemInfo<typeof dataSource[number]>) => {
            return (
                <SettingsRowItem
                    item={item}
                    title={t(item.title)}
                    rightTitle={item.rightTxt}
                    style={styles.container}
                    titleContainerStyle={styles.titleContainer}
                    rightTitleStyle={styles.subtitle}
                    disabled
                    position={index + 1}
                    total={dataSource.length}
                />
            );
        },
        [],
    );

    return (
        <View
            style={[gStyles.settingsContainer, { backgroundColor: background }]}
        >
            {isWeb && (
                <WebHeader
                    title={t(SETTINGS_SYSTEM_INFORMATION)}
                    disableFocusOnMount
                />
            )}
            <FlatList
                style={[
                    gStyles.settingsContentContainer,
                    { backgroundColor: background },
                ]}
                nestedScrollEnabled
                data={dataSource}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
                showsHorizontalScrollIndicator={false}
                accessibilityRole="menu"
            />
        </View>
    );
};

export default AboutPage;

function keyExtractor(item: { id: string }) {
    return item.id;
}
